
const headers = [
    {
      label: 'วันเวลาไกล่เกลี่ยผู้ร้อง',
      field: 'customerMediate',
      tdClass: '',
    },
    {
      label: 'วันเวลาไกล่เกลี่ยผู้ถูกร้อง',
      field: 'companyMediate',
      tdClass: '',
    },
    {
      label: 'สถานะการอนุมัติจดหมายเชิญ',
      field: 'committeeStatus',      
    },
    {
      label: 'เรื่องร้องทุกข์',
      field: 'complaintCode',      
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers